import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import '@scss/wrong_page.scss';
import {withTranslation} from "react-i18next";

export const WrongPage = (props) => {
    const {i18n} = props;
    const isLangEn = i18n.language === 'en'

    return (
        <Grid className="wrong-page" container spacing={2} justifyContent="center" alignItems="center">
            <Grid item xs={12}>
                <Typography variant="h2" align="center" className="title-header">
                    {isLangEn
                        ? ':( Something went wrong...'
                        : ':( Что-то пошло не так...'
                    }
                </Typography>
                <Typography variant="h6" align="center">
                    {isLangEn
                        ? 'Please reload the page and try again.'
                        : 'Перезагрузите, пожалуйста, страницу и попробуйте снова.'
                    }
                </Typography>
            </Grid>
        </Grid>
    );
};
export default withTranslation()(WrongPage);
